/* eslint-disable @typescript-eslint/no-unused-vars */

import { Delete, Edit } from "@mui/icons-material";
import { Grid, Typography, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isTrueValue } from "@utils/utilsValidators";
import EuroIcon from "@mui/icons-material/Euro";

// Interface
interface MacroCategoriesCstInterface {
  data: any;
  index: number;
  onEdit?: (data: any, index: number) => void;
  onDelete?: (data: any) => void;
  isDetail?: boolean;
}

// eslint-disable-next-line no-empty-pattern
const MacroCategoriesAccordionCst: React.FC<MacroCategoriesCstInterface> = ({
  data,
  index,
  onEdit,
  onDelete,
  isDetail,
}) => {
  const { t } = useTranslation(["form"]);

  const getInternalString = (internal: any) => {
    if (!!internal && isTrueValue(internal.toString())) {
      return "Interno";
    } else {
      return "Esterno";
    }
  };

  const getArrayString = (array: any) => {
    if (!!array && !!array.length) {
      const newArray = array.map((item: any) => {
        return item.label || item.sap_number || item.title;
      });
      return newArray.join();
    } else {
      return "-";
    }
  };

  return (
    <>
      <Grid container alignItems="center" justifyContent="space-between">
        {!isDetail && (
          <Grid item xs={12} sm={1}>
            <IconButton
              color={"primary"}
              aria-label="delete category"
              onClick={() => onDelete && onDelete(data)}
              disabled={
                typeof data?.deletable === "boolean" ? !data?.deletable : false
              }
            >
              <Delete />
            </IconButton>
            <IconButton
              aria-label="edit category"
              onClick={() => {
                onEdit && onEdit(data, index);
              }}
              edge="end"
            >
              <Edit />
            </IconButton>
          </Grid>
        )}
        <Grid item xs={12} sm={11}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("category-form.typology")}
              </Typography>
              <Typography>
                {data.internal
                  ? getInternalString(data.internal)
                  : getInternalString(data.macro_category?.internal)}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("category-form.account")}
              </Typography>
              <Typography>
                {data.account?.label
                  ? data.account?.label
                  : getArrayString(data.account)}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("category-form.macro-category")}
              </Typography>
              <Typography>
                {data.macro_category?.label
                  ? data.macro_category?.label
                  : getArrayString(data.macro_category)}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("category-form.budget")}
              </Typography>
              <Typography
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {data.allocated_budget ? (
                  <>
                    {new Intl.NumberFormat("it-IT", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(Number(data.allocated_budget))}
                    <EuroIcon fontSize="small" />
                  </>
                ) : (
                  "-"
                )}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default MacroCategoriesAccordionCst;
